import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_URL_forgot_password } from "../constants";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email.trim()) {
      setError("Por favor ingresa tu correo electrónico.");
      return;
    }

    setLoading(true);
    try {
      const resp = await axios.post(API_URL_forgot_password, { email: email.trim() });
      setMessage(
        resp?.data?.detail ||
          "Si la cuenta existe, enviaremos un enlace para restablecer la contraseña."
      );
    } catch (err) {
      console.error("forgot-password error:", err);
      setError("Ocurrió un error. Inténtalo de nuevo más tarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoSection}>
          <img src="/logo192.png" alt="LSSI" style={styles.logo} />
          <h1 style={styles.brand}>Restablecer Contraseña</h1>
          <p style={styles.subtitle}>
            Ingresa el correo de tu cuenta y te enviaremos un enlace para recuperarla.
          </p>
        </div>

        <form style={styles.form} onSubmit={handleSubmit}>
          <div style={styles.fieldGroup}>
            <label htmlFor="email" style={styles.label}>Correo electrónico</label>
            <input
              id="email"
              type="email"
              placeholder="tu@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              style={styles.input}
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}
          {message && <div style={styles.success}>{message}</div>}

          <button type="submit" disabled={loading} style={styles.submitButton}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>

          <div style={styles.backLink}>
            <Link to="/">Volver a iniciar sesión</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "calc(100vh - 80px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f3f4f6",
    padding: "20px",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
    padding: "40px 36px 32px",
  },
  logoSection: { textAlign: "center", marginBottom: "32px" },
  logo: { width: "72px", height: "72px", marginBottom: "16px", borderRadius: "12px" },
  brand: { fontSize: "1.5rem", fontWeight: 700, color: "#1a1a2e", margin: "0 0 8px" },
  subtitle: { fontSize: "0.875rem", color: "#6b7280", margin: 0 },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  fieldGroup: { display: "flex", flexDirection: "column", gap: "6px" },
  label: { fontSize: "0.8125rem", fontWeight: 600, color: "#374151" },
  input: {
    width: "100%",
    padding: "11px 14px",
    fontSize: "0.9375rem",
    border: "1.5px solid #e5e7eb",
    borderRadius: "10px",
    backgroundColor: "#f9fafb",
    boxSizing: "border-box",
  },
  error: {
    padding: "10px 14px",
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: "10px",
    color: "#dc2626",
    fontSize: "0.8125rem",
  },
  success: {
    padding: "10px 14px",
    backgroundColor: "#ecfdf5",
    border: "1px solid #a7f3d0",
    borderRadius: "10px",
    color: "#047857",
    fontSize: "0.8125rem",
  },
  submitButton: {
    width: "100%",
    padding: "12px",
    fontSize: "0.9375rem",
    fontWeight: 600,
    color: "#ffffff",
    backgroundColor: "#dc3545",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(220, 53, 69, 0.25)",
  },
  backLink: { textAlign: "center", fontSize: "0.8125rem" },
};

export default ForgotPassword;
